module.exports = __webpack_public_path__ + "img/medium_manage.481cbb57.png";